import publicTheme from '../public/theme'

const authTheme = publicTheme

export default authTheme
